<!-- components/UsageTips.vue -->
<template>
    <section class="usage-tips">
      <h4>六、使用技巧</h4>
  
      <!-- 查询建议 -->
      <section class="tip-section">
        <h4>🎯 查询建议</h4>
        <ol>
          <li>优先使用综合查询</li>
          <li>补齐查询注意格式</li>
          <li>猎魔查询使用普通格式</li>
          <li>建议早开通会员</li>
        </ol>
      </section>
  
      <!-- 注意事项 -->
      <section class="tip-section">
        <h4>⚠️ 注意事项</h4>
        <ol>
          <li>手机补齐必须前三后四</li>
          <li>身份证补齐必须含生日</li>
          <li>地区查询暂不支持镇村</li>
          <li>充值有优惠多留意</li>
        </ol>
      </section>
  
      <!-- 遇到问题 -->
      <section class="tip-section">
        <h4>🆘 遇到问题</h4>
        <ul>
          <li>24小时专业客服</li>
          <li>纠纷速裁系统</li>
          <li>技术支持通道</li>
          <li>反馈建议频道</li>
        </ul>
      </section>
    </section>
  </template>
  
  <script>
  export default {
    name: 'UsageTips'
  }
  </script>
  
  <style scoped>
  .tip-section {
    margin-bottom: 1.5em;
    padding: 15px;
    background: #fff1f2;
    border-left: 4px solid #f43f5e;
  }
  </style>